import { render, staticRenderFns } from "./PropertyRepairList.vue?vue&type=template&id=09e50854&scoped=true&"
import script from "./PropertyRepairList.vue?vue&type=script&lang=js&"
export * from "./PropertyRepairList.vue?vue&type=script&lang=js&"
import style0 from "./PropertyRepairList.vue?vue&type=style&index=0&id=09e50854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e50854",
  null
  
)

export default component.exports